import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { action } from 'satcheljs/lib/legacy';
import { DragOperationType, CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';
import { isDragging } from './isDragging';

/**
 * Sets the initial state when we begin a drag operation, this happens when the user first starts
 * dragging and gets called from the draggable component's onDragStart event.
 * @param surfaceStore The surface store
 * @param item The item to be dragged
 * @param dragType The type of drag operation being performed, i.e., drag/resize
 */
export let initializeDragOperation = action('initializeDragOperation')(
    function initializeDragOperation(
        surfaceStore: CalendarSurfaceStore,
        item: CalendarEvent,
        dragType: DragOperationType
    ): void {
        let { dragDropState } = surfaceStore;
        if (!isDragging(dragDropState)) {
            dragDropState.draggedItemModel = item;
            dragDropState.dragType = dragType;
        }
    }
);
